import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col, Tab, Tabs } from "react-bootstrap";
import "./PreScheduling.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, ToastMessage } from '../../components'
import { COMPANIES, SIM, NAO } from '../../utils/constants';
import { weekdays } from "./weekdays";

function PreScheduling(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
       
    const providerPreScheduling       = useSelector(state => state.provider.providerIdPreScheduling);
    const preSchedulingDetails        = useSelector(state => state.preScheduling.preSchedulingDetails);
    const cdList                      = useSelector(state => state.cdList);
    const timeZoneList                = useSelector(state => state.preScheduling.timeZoneList);
    const workHourTypeList            = useSelector(state => state.preScheduling.workHourTypeList);
    const preSchedulingLoading        = useSelector(state => state.preScheduling.preSchedulingLoading);
    const selectedPreScheduling       = useSelector(state => state.preScheduling.selectedPreScheduling);    
    const fetchedPreSchedulingDetails = useSelector(state => state.preScheduling.fetchedPreSchedulingDetails);
    const getPreScheduling            = useSelector(state => state.preScheduling.getPreScheduling);
    
    const [cdOptions, setCdOptions] = useState([
        {id: "", message: ""}
    ]);
	    	    
	const pageMessages = messages[lang].preSchedulingPage
	const titlePage    = messages[lang].preSchedulingPage.title + ": " + providerPreScheduling.data.nome;

    const preSchedulingToast = useSelector(state => state.preScheduling.preSchedulingToast);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');
    const [validated,    setValidated]    = useState(false);
    
    const [formFields, setFormFields] = useState({
        descricao: '',
        capacidade: '',
        empresa: COMPANIES.RENNER.ID,
        cd: '',
        dataInicial: '',
        dataFinal: '',
        tipoHoraTrabalho: '',
        horaInicial: '',
        horaFinal: '',
        fusoHorario: '',
        recebimentoCaixaria: SIM,
        recebimentoDeEncabidado: SIM,
        transferencia: SIM,
        ativo: SIM,
        fornecedor: providerPreScheduling.data.id,
        diasDeTrabalho: []
    });  
        
	const pageBack = () => {
		props.history.push(`/pre-scheduling-list`);
    };

    const [isEdit, setIsEdit] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity()) {
            if (isEdit) {
                dispatch({
                    type: 'EDIT_PRE_SCHEDULING_DETAILS',
                    payload: formFields
                })
            } else {
                dispatch({
                    type: 'CREATE_NEW_PRE_SCHEDULING',
                    payload: formFields
                })
            }
        }
    
        setValidated(true);
    };

    const handleOnWeekDayChange = (event, value) => {
        if (!formFields.diasDeTrabalho.includes(value)) {
            let newArray = formFields.diasDeTrabalho

            newArray.push(value)

            setFormFields(
                { ...formFields, diasDeTrabalho: newArray },
            )
        } else {  
            let newArray = formFields.diasDeTrabalho

            var index = newArray.indexOf(value);
            if (index !== -1) {
                newArray.splice(index, 1);
            }
            setFormFields(
                { ...formFields, diasDeTrabalho: newArray },
            )
        }
    };

    const formatWeekDays = (fetchedWeekDays) => {
        let newArray = []

        for (let i = 0; i < fetchedWeekDays.horasDeTrabalho[0].diasDeTrabalho.length; i++) {
            newArray.push(fetchedWeekDays.horasDeTrabalho[0].diasDeTrabalho[i].diaSemana)
        }

        return newArray
    };

    useEffect(() => {	
        setShowToast(preSchedulingToast.showToast)
        setMessageError(preSchedulingToast.message)
        setMessageType(preSchedulingToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [preSchedulingToast]);

    useEffect(() => {	
        if (getPreScheduling) {
            setIsEdit(true)

            dispatch({
                type: 'GET_PRE_SCHEDULING_DETAILS',
                payload: {
                    preSchedulingId: getPreScheduling
                }
            })

            dispatch({ type: 'SET_GET_PRE_SCHEDULING', payload: null });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getPreScheduling]);
        
	useEffect(() => {        
        dispatch({
            type: 'UNSET_PROVIDER_PRE_SCHEDULING',
            payload: {
                id: null,
                data: providerPreScheduling.data
            }
        })

        dispatch({
			type: 'SET_PRE_SCHEDULING_TOAST',
			payload: {
                showToast: false,
                message: "",
                messageType: "toast-success"
            }
		})

        dispatch({ type: 'CLEAN_PRE_SCHEDULING_DETAILS' })
        dispatch({ type: 'GET_TIME_ZONES' })
        dispatch({ type: 'GET_WORK_HOUR_TYPES' })
        dispatch({ type: 'GET_CDS' })

        if (selectedPreScheduling.id) {
            setIsEdit(true)

            dispatch({
                type: 'UNSET_SELECTED_PRE_SCHEDULING',
                payload: {
                    id: null,
                    data: selectedPreScheduling.data
                }
            })

            dispatch({
                type: 'GET_PRE_SCHEDULING_DETAILS',
                payload: {
                    preSchedulingId: selectedPreScheduling.data.id
                }
            })
        } else {
            setIsEdit(false)
         
            dispatch({
                type: 'UNSET_SELECTED_PRE_SCHEDULING',
                payload: {
                    id: null,
                    data: {}
                }
            })
        }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (!isEdit) {
            updateCdField(COMPANIES.RENNER.ID)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cdList]);

    useEffect(() => {
        if (isEdit) {  
            updateCdField(fetchedPreSchedulingDetails.empresa.id)

            setFormFields({
                id: fetchedPreSchedulingDetails.id,
                idHoraTrabalho: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].id : '',
                descricao: fetchedPreSchedulingDetails.descricao,
                capacidade: fetchedPreSchedulingDetails.capacidade,
                empresa: fetchedPreSchedulingDetails.empresa.id,
                dataInicial: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].dataInicial : '',
                dataFinal: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].dataFinal : '',
                tipoHoraTrabalho: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].tipoHoraTrabalho.id.toString() : '',
                horaInicial: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].horaInicial : '',
                horaFinal: fetchedPreSchedulingDetails.horasDeTrabalho ? fetchedPreSchedulingDetails.horasDeTrabalho[0].horaFinal : '',
                fusoHorario: fetchedPreSchedulingDetails.fusoHorario.id,
                recebimentoCaixaria: fetchedPreSchedulingDetails.recebimentoCaixaria,
                recebimentoDeEncabidado: fetchedPreSchedulingDetails.recebimentoDeEncabidado,
                transferencia: fetchedPreSchedulingDetails.transferencia,
                ativo: fetchedPreSchedulingDetails.ativo,
                fornecedor: providerPreScheduling.data.id,
                diasDeTrabalho: formatWeekDays(fetchedPreSchedulingDetails)
            })
        } else {
            setFormFields({
                descricao: '',
                capacidade: '',
                empresa: COMPANIES.RENNER.ID,
                cd: '',
                dataInicial: '',
                dataFinal: '',
                horaInicial: '',
                horaFinal: '',
                fusoHorario: '',
                recebimentoCaixaria: SIM,
                recebimentoDeEncabidado: SIM,
                transferencia: SIM,
                ativo: SIM,
                fornecedor: providerPreScheduling.data.id,
                diasDeTrabalho: []
            })

        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchedPreSchedulingDetails]);

    useEffect(() => {
        if (timeZoneList[0] && timeZoneList[0].id && !isEdit) {
            let index = timeZoneList.findIndex(function(timezone) {
                return timezone.descricao === "(UTC-03:00) Brasília"
            });

            setFormFields({ ...formFields, fusoHorario: timeZoneList[index].id.toString() })
        }        
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeZoneList]);

    useEffect(() => {
        if (workHourTypeList[0] && workHourTypeList[0].id && !isEdit) {
            setFormFields({ ...formFields, tipoHoraTrabalho: workHourTypeList[0].id.toString() })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [workHourTypeList]);
    
    useEffect(() => {
        if (cdOptions[0] && cdOptions[0].id) {
            if (fetchedPreSchedulingDetails.id) {
                setFormFields({ ...formFields, cd: fetchedPreSchedulingDetails.cd.id })              
            } else {
                setFormFields({ ...formFields, cd: cdOptions[0].id.toString() })
            }
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cdOptions]);

    const companyOptions = [
        { id: COMPANIES.RENNER.ID, message: COMPANIES.RENNER.NAME },
        { id: COMPANIES.CAMICADO.ID, message: COMPANIES.CAMICADO.NAME },
        { id: COMPANIES.YOUCOM.ID, message: COMPANIES.YOUCOM.NAME },
    ];

    const updateCdField = (company) => {
        let newCompany = ''

        if (company === COMPANIES.RENNER.ID) {
            newCompany = COMPANIES.RENNER.NAME
        }

        if (company === COMPANIES.CAMICADO.ID) {
            newCompany = COMPANIES.CAMICADO.NAME
        }

        if (company === COMPANIES.YOUCOM.ID) {
            newCompany = COMPANIES.YOUCOM.NAME
        }

        let newCdOptions = cdList.reduce(function(filtered, item) {
            if (item.empresas[0] === newCompany) {
               var newValue = { 
                    key: item.codigo, 
                    id: item.codigo,
                    message: item.nome,
                }
               filtered.push(newValue);
            }
            return filtered;
        }, []);

        setCdOptions(newCdOptions)
    }

    const updateCompany = (fields) => {
        setFormFields(fields)
        updateCdField(fields.empresa)
    };

    const updateWorkHourType = (fields) => {
        setFormFields(fields)

        if (fields.tipoHoraTrabalho !== '2') {
            setFormFields({...fields, dataFinal: ''})
        }
    };

    const saveButton = disabled => () =>
        <ButtonStandard
            id="norm_save_button"
            type="submit"
            text={messages[lang].save}
            textClass="text-2"
            isLoading={preSchedulingLoading}
            disabled={disabled}
            className="btn btn-primary btn-save btn-light"
        />;

	return (
		<div className="provider-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

            {
                providerPreScheduling.data.id
                ?
                <div>
                    <Container className="pt-3 justify-content-start">
                        <div key={preSchedulingDetails.id}>
                        <Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
                            <Row>
                                <Form.Group as={Col} xs={6} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.descricao}</Form.Label>

                                    <Form.Control
                                        required
                                        className="text-2 border-radius-full"
                                        type="text"
                                        defaultValue={formFields.descricao}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, descricao: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>

                                </Form.Group>

                                <Form.Group as={Col} xs={6} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.capacidade}</Form.Label>
                                    
                                    <Form.Control
                                        required
                                        className="text-2 border-radius-full"
                                        type="number"
                                        defaultValue={formFields.capacidade}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, capacidade: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>
                                </Form.Group>	
                            </Row>
                        
                            <Row>
                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.empresa}</Form.Label>

                                    <Form.Control
                                        required
                                        as="select"
                                        className="text-2 border-radius-full"
                                        type="text"
                                        value={formFields.empresa || ''}
                                        disabled={preSchedulingLoading}
                                        onChange={event => updateCompany(
                                            { ...formFields, empresa: event.target.value },
                                        )}
                                    >
                                        {
                                            companyOptions.map(value => (
                                                <option key={value.message} value={value.id}>{value.message}</option>
                                            ))
                                        }
                                    </Form.Control>

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>

                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.cd}</Form.Label>
                                    
                                    <Form.Control
                                        required
                                        as="select"
                                        className="text-2 border-radius-full"
                                        type="number"
                                        value={formFields.cd || ''}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, cd: event.target.value },
                                        )}
                                    >
                                        {
                                            cdOptions.map(value => (
                                                <option key={value.id} value={value.id}>{value.message}</option>
                                            ))
                                        }
                                    </Form.Control>

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>

                                </Form.Group>	

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.dtInicial}</Form.Label>

                                    <Form.Control
                                        required
                                        className="text-2 border-radius-full"
                                        type="date"
                                        value={formFields.dataInicial || ''}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, dataInicial: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>

                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.dtFinal}</Form.Label>
                                    
                                    <Form.Control
                                        required={formFields.tipoHoraTrabalho === '2'}
                                        className="text-2 border-radius-full"
                                        type="date"
                                        value={formFields.dataFinal || ''}
                                        disabled={preSchedulingLoading || (formFields.tipoHoraTrabalho !== '2' ? true : false)}
                                        onChange={event => setFormFields(
                                            { ...formFields, dataFinal: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>
                                </Form.Group>	
                            </Row>

                            <Row>
                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.tipoHoraTrabalho}</Form.Label>

                                    <Form.Control
                                        required
                                        as="select"
                                        className="text-2 border-radius-full"
                                        type="text"
                                        value={formFields.tipoHoraTrabalho || ''}
                                        disabled={preSchedulingLoading}
                                        onChange={event => updateWorkHourType(
                                            { ...formFields, tipoHoraTrabalho: event.target.value },
                                        )}
                                    >
                                        {
                                            workHourTypeList.map(value => (
                                                <option key={value.id} value={value.id}>{value.descricao}</option>
                                            ))
                                        }
                                    </Form.Control>

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>
                                </Form.Group>	
        
                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.horaInicial}</Form.Label>

                                    <Form.Control
                                        required
                                        className="text-2 border-radius-full"
                                        type="time"
                                        defaultValue={formFields.horaInicial}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, horaInicial: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>

                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.horaFinal}</Form.Label>
                                    
                                    <Form.Control
                                        required
                                        className="text-2 border-radius-full"
                                        type="time"
                                        defaultValue={formFields.horaFinal}
                                        disabled={preSchedulingLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, horaFinal: event.target.value },
                                        )}
                                        />

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.fusoHorario}</Form.Label>

                                    <Form.Control
                                        required
                                        as="select"
                                        className="text-2 border-radius-full"
                                        type="text"
                                        value={formFields.fusoHorario || ''}
                                        disabled={true}
                                        onChange={event => setFormFields(
                                            { ...formFields, fusoHorario: event.target.value },
                                        )}
                                    >
                                        {
                                            timeZoneList.map(value => (
                                                <option key={value.id} value={value.id}>{value.descricao}</option>
                                            ))
                                        }
                                    </Form.Control>

                                    <Form.Control.Feedback type="invalid">
                                        {messages[lang].requiredField}
                                    </Form.Control.Feedback>
                                </Form.Group>	
                            </Row>

                            <Row>
                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.recebimentoCaixaria}</Form.Label>

                                    <div key={`inline-radio-caixaria`} className="text-2">
                                            <Form.Check
                                                inline
                                                label={messages[lang].yes}
                                                name="caixariaRadio"
                                                type="radio"
                                                id={`inline-radio-caixaria-1`}
                                                checked={formFields.recebimentoCaixaria === SIM}
                                                disabled={preSchedulingLoading}
                                                onChange={event => setFormFields(
                                                    { ...formFields, recebimentoCaixaria: SIM },
                                                )}
                                            />
                                            <Form.Check
                                                inline
                                                label={messages[lang].no}
                                                name="caixariaRadio"
                                                type="radio"
                                                id={`inline-radio-caixaria-2`} 
                                                checked={formFields.recebimentoCaixaria === NAO}
                                                disabled={preSchedulingLoading}
                                                onChange={event => setFormFields(
                                                    { ...formFields, recebimentoCaixaria: NAO },
                                                )}
                                            />
                                    </div>
                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.recebimentoDeEncabidado}</Form.Label>

                                    <div key={`inline-radio-encabidado`} className="text-2">
                                            <Form.Check
                                                inline
                                                label={messages[lang].yes}
                                                name="encabidadoRadio"
                                                type="radio"
                                                id={`inline-radio-encabidado-1`}
                                                checked={formFields.recebimentoDeEncabidado === SIM}
                                                disabled={preSchedulingLoading}
                                                onChange={event => setFormFields(
                                                    { ...formFields, recebimentoDeEncabidado: SIM },
                                                )}
                                            />
                                            <Form.Check
                                                inline
                                                label={messages[lang].no}
                                                name="encabidadoRadio"
                                                type="radio"
                                                id={`inline-radio-encabidado-2`}
                                                checked={formFields.recebimentoDeEncabidado === NAO}
                                                disabled={preSchedulingLoading}
                                                onChange={event => setFormFields(
                                                    { ...formFields, recebimentoDeEncabidado: NAO },
                                                )}
                                            />
                                    </div>
                                </Form.Group>	

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.transferencia}</Form.Label>

                                    <div key={`inline-radio-transferencia`} className="text-2">
                                        <Form.Check
                                            inline
                                            label={messages[lang].yes}
                                            name="transferenciaRadio"
                                            type="radio"
                                            id={`inline-radio-transferencia-1`}
                                            checked={formFields.transferencia === SIM}
                                            disabled={preSchedulingLoading}
                                            onChange={event => setFormFields(
                                                { ...formFields, transferencia: SIM },
                                            )}
                                        />
                                        <Form.Check
                                            inline
                                            label={messages[lang].no}
                                            name="transferenciaRadio"
                                            type="radio"
                                            id={`inline-radio-transferencia-2`}
                                            checked={formFields.transferencia === NAO}
                                            disabled={preSchedulingLoading}
                                            onChange={event => setFormFields(
                                                { ...formFields, transferencia: NAO },
                                            )}
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group as={Col} xs={3} className="mt-1">
                                    <Form.Label className="text-2">{pageMessages.ativo}</Form.Label>

                                    <div key={`inline-radio-ativo`} className="text-2">
                                        <Form.Check
                                            inline
                                            label={messages[lang].yes}
                                            name="ativoRadio"
                                            type="radio"
                                            id={`inline-radio-ativo-1`}
                                            checked={formFields.ativo === SIM}
                                            disabled={preSchedulingLoading}
                                            onChange={event => setFormFields(
                                                { ...formFields, ativo: SIM },
                                            )}
                                        />
                                        <Form.Check
                                            inline
                                            label={messages[lang].no}
                                            name="ativoRadio"
                                            type="radio"
                                            id={`inline-radio-ativo-2`}
                                            checked={formFields.ativo === NAO}
                                            disabled={preSchedulingLoading}
                                            onChange={event => setFormFields(
                                                { ...formFields, ativo: NAO },
                                            )}
                                        />
                                    </div>
                                </Form.Group>	
                            </Row>

                            <Tabs
                                defaultActiveKey="weekdays"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="weekdays" title="Dias da Semana">
                                    {['checkbox'].map((type) => (
                                        <div key={`inline-${type}`} className="mb-3">
                                        <Form.Group as={Col} xs={"auto"} className="mt-1">
                                        {weekdays.map(({ name, value }, index) => {
                                            return (
                                                 <Form.Check
                                                 inline
                                                 label={name}
                                                 name="group1"
                                                 type={type}
                                                 checked={formFields.diasDeTrabalho.includes(value)}
                                                 onChange={(event) => handleOnWeekDayChange(event, value)}
                                                 id={`inline-${type}-${name}`}
                                             />
                                            );
                                        })}
                                        </Form.Group>
                                        </div>
                                    ))}
                                </Tab>
                            </Tabs>
                            <FooterActions
				                ButtonGroupRight={saveButton(false)}/>
                        </Form>
                        </div>
                    </Container>
                </div>
                :
                null
            }
            
		</div>
	)
}

export default withRouter(PreScheduling);